export interface Category {
  id: number;
  name: string;
  type: 'revenue' | 'expense' | 'other';
  displayOrder: number;
  group: 'revenue' | 'departmental' | 'undistributed' | 'fixed';
}

export const HOTEL_CATEGORIES: Category[] = [
  // Revenue Categories
  { id: 1, name: 'Revenue', type: 'revenue', displayOrder: 1, group: 'revenue' },

  // Expense Categories - Main Groups
  { id: 2, name: 'Departmental Expenses', type: 'expense', displayOrder: 2, group: 'departmental' },
  { id: 3, name: 'Undistributed Operating Expenses', type: 'expense', displayOrder: 3, group: 'undistributed' },
  { id: 4, name: 'Fixed Charges', type: 'expense', displayOrder: 4, group: 'fixed' },
];

// Helper functions to get categories by type
export const getRevenueCategories = () => HOTEL_CATEGORIES.filter(cat => cat.type === 'revenue');
export const getExpenseCategories = () => HOTEL_CATEGORIES.filter(cat => cat.type === 'expense');

// Helper function to get categories by group
export const getCategoriesByGroup = (group: Category['group']) =>
  HOTEL_CATEGORIES.filter(cat => cat.group === group);

// Helper function to get category by ID
export const getCategoryById = (id: number) =>
  HOTEL_CATEGORIES.find(cat => cat.id === id);

// Helper function to get category by name
export const getCategoryByName = (name: string) =>
  HOTEL_CATEGORIES.find(cat => cat.name === name);